import React from 'react'

import { withRouter } from 'react-router-dom'

import moment from 'moment'

import { connect } from 'react-redux'

import BugComments from './comments'
import Logs from './logs'
import EmailModal from './email-modal'
import Uploader from './uploader'

import {
    Form,
    Input,
    Button,
    message,
    Icon,
    Card,
    Row,
    Modal,
    Rate,
    Col,
    Upload,
    Badge,
    Select,
} from 'antd'

import { API_ENDPOINT } from '../../index'

import {
    _getBug,
    _postCreateBug,
    _postClaimBug,
    _postReassignBug,
    _postEditBug,   
    _postCloseBug,
    _postReopenBug,
    _postSubmitBugComment,
    _getBugLogs,
    _sendBugUpdateEmailToUser,
    _postBugLog,
} from '../../services'
import { STATUS_CODES } from 'http';

const { confirm } = Modal

const STATUS = {
    CLOSED: 'CLOSED',
    INPROGRESS: 'IN PROGRESS',
    OPEN: 'OPEN'
}

const TYPE = {
    GENERAL: 'General',
    TECHINICAL: 'Technical',
    SUGGESTIONS: 'Suggestions'
}

class BugEditor extends React.Component {
    render() {
        const { getFieldDecorator } = this.props.form
        
        const { bug, imageUrl, readOnly, loading, renderModal, modalVisible, emailModalVisible } = this.state

        if (loading) {
            return <div>loading...</div>
        }

        return (
            <Card
                title={
                    readOnly && 
                    <Row type="flex" justify="space-between">
                        <Col>
                            {bug.refNumber} 
                            {readOnly && bug.agent && this.props.user._id == bug.agent.id &&
                            <Button
                            type="primary"
                            ghost
                            style={{marginLeft: 8}}
                            onClick={()=>this.setState({ readOnly: false})}>Edit</Button>}
                        </Col>
                        <Col>
                            <div style={{ marginBottom: 4 }}>
                                Submitted by: <span style={{ color: 'rgba(0,0,0,0.65)' }}>{bug.createdBy.name}</span>
                            </div>
                        </Col>
                    </Row>
                }
            >
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .screenshot:hover {
                        opacity: 0.7;
                    }

                    .bigger-text {
                        font-size: 16px;
                        color: rgba(0,0,0,0.85);
                    }
                `}} />
                {renderModal &&
                    <Modal
                        onOk={this.handleReassign}
                        afterClose={() => this.setState({ reassignUserEmail: false, renderModal: false })}
                        onCancel={() => this.setState({ modalVisible: false })}
                        title="Giving up?"
                        closable={false}
                        centered
                        visible={modalVisible}
                        okButtonProps={{
                            loading,
                            disabled: !this.state.reassignReason
                        }}
                    >
                        <Input
                            placeholder="jasper@eezee.com.sg"
                            onChange={this.handleReassignInputChange}
                            style={{ width: '100%', marginBottom: 16 }}
                        />
                        <Input.TextArea
                            rows={2}
                            placeholder="Reason"
                            onChange={(e)=>this.setState({reassignReason: e.target.value})}
                            style={{width: '100%'}}
                        />
                    </Modal>}
                {emailModalVisible &&
                    <EmailModal 
                        afterClose={() => this.setState({emailModalVisible : false})}
                        onCancel={() => this.setState({emailModalVisible : false})}
                        handleSendEmail={this.handleSendEmail}
                        bug={bug}
                    />
                }
                {readOnly &&
                    <div style={{ marginBottom: 24,display:'flex',flexDirection:'row' }}>

                        <div>
                            <span
                                style={{ marginRight: 12 }}
                            >Claimed by:</span>
                            {bug.agent ?
                                <span>
                                {bug.agent.name}
                                {bug.status == "CLOSED" && <Button
                                    type="danger"
                                    size="small"
                                    style={{marginLeft: 16}}
                                    onClick={this.handleConfirmReopen}
                                >Reopen</Button>}
                                </span>
                                :
                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={this.handleClaim}>
                                    Claim
                                </Button>}
                            {!bug.agent && bug.status != "CLOSED" &&
                                <span style={{ marginLeft: 16 }}>
                                    <Button
                                        onClick={() => this.setState({ modalVisible: true, renderModal: true })}
                                        size="small" type="danger">Assign</Button>
                                </span>
                            }
                            {bug.agent && this.props.user._id == bug.agent.id && bug.status != "CLOSED" &&
                                <span style={{ marginLeft: 16 }}>
                                    <Button
                                        onClick={() => this.setState({ modalVisible: true, renderModal: true })}
                                        size="small" type="danger">Reassign</Button>
                                    <Button
                                        onClick={this.handleConfirmClose}
                                        size="small"
                                        style={{ marginLeft: 16 }}
                                        type="primary"
                                    >Close</Button>
                                </span>
                            }
                        </div>

                        <div style={{marginLeft: 'auto'}}>
                            {this.renderStatus(bug.status)}
                        </div>

                    </div>}
                    
                    <Row>
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            <h1 className="editor-section-header">Bug Details</h1>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item label="I'm writing about">
                                        {readOnly ?
                                            <span className="bigger-text">{bug.type}</span> :
                                            getFieldDecorator('type', {
                                                initialValue: 'General'
                                            })(
                                                <Select
                                                style={{ width: '100%' }}
                                                onChange={(e) => this.setState({type: e})}
                                                >
                                                    {Object.keys(TYPE).map(_type => {
                                                    return <Select.Option value={TYPE[_type]} key={TYPE[_type]}>{TYPE[_type]}</Select.Option>  
                                                    })}
                                                </Select>
                                                )
                                        }
                                    </Form.Item>
                                </Col>   
                                {(this.state.bug.type=='Technical' || this.state.type) && <Col span={8}>
                                    <Form.Item label="URL">
                                        {readOnly ?
                                            <span className="bigger-text">{bug.url}</span>
                                            :
                                            getFieldDecorator('url', {
                                                initialValue: bug.url,
                                                rules: [{ required: true, message: 'URL is required!' }],
                                            })(
                                                <Input
                                                    style={{ width: '100%' }}
                                                    placeholder="https://eezee.sg/material-handling/ladders-platforms"
                                                />,
                                            )}
                                    </Form.Item>
                                </Col>}

                            </Row>
                            <Row gutter={24}>
                                <Col span={10}>
                                    <Form.Item label="Eezee Account Email">
                                        {readOnly ?
                                            <span className="bigger-text">{bug.eezeeAccountEmail ? bug.eezeeAccountEmail : '-'}</span>
                                            :
                                            getFieldDecorator('eezeeAccountEmail', {
                                                initialValue: bug.eezeeAccountEmail
                                            })(
                                                <Input
                                                    style={{ width: '100%' }}
                                                    placeholder="user@company.com"
                                                />,
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={14}>
                                    <Form.Item label="Level of Severity">
                                        {getFieldDecorator('severity', {
                                            initialValue: bug.severity || 0,
                                        })(
                                            <Rate
                                                disabled={Boolean(readOnly)}
                                                style={{
                                                    color: '#f5222d'
                                                }}
                                                character={<Icon type="frown" />}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={10}>
                                    <Form.Item label="Describe the problem">
                                            {readOnly ?
                                                <span className="bigger-text no-line-height">{bug.description}</span>
                                                :
                                                getFieldDecorator('description', {
                                                    initialValue: bug.description,
                                                    rules: [{ required: true, message: 'Description is required!' }],
                                                })(
                                                    <Input.TextArea
                                                        rows={4}
                                                        style={{width:'100%'}}
                                                        placeholder="Page won't load, click button got problem"
                                                    />,
                                                )}
                                    </Form.Item>
                                </Col>
                                <Col span={14}>
                                    <Form.Item label="Screenshot">
                                        <div style={{ width: '100%', height: '100%' }}>
                                            <Uploader 
                                                imageUrl= {imageUrl}
                                                readOnly={typeof(readOnly)!='undefined' && readOnly}
                                                maxNumOfImages={3}
                                                handleChange = {this.handleChange}
                                                />
                                        </div>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <div className="editor-section-header">
                                <h1 style={{marginBottom: '0px'}}>Contact Details</h1>
                                {readOnly && bug.agent && <Button
                                    onClick={()=> this.setState({ emailModalVisible: true })}
                                    size="small"
                                    style={{ marginLeft: 16 }}
                                    type="primary"
                                >Email User</Button>}
                            </div>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item label="User Email">
                                            {readOnly ?
                                                <span className="bigger-text">{bug.reportedByEmail ? bug.reportedByEmail : '-'}</span>
                                                :
                                                getFieldDecorator('reportedByEmail', {
                                                    initialValue: typeof(bug.reportedByEmail)!='undefined' ? bug.reportedByEmail : (this.props.user.details && this.props.user.details.email)
                                                })(
                                                    <Input
                                                        style={{ width: '100%' }}
                                                        placeholder="user@company.com"
                                                    />,
                                                )
                                            }
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <p className="form-field-label">
                                        Origin: </p>
                                    <span className="bigger-text">{bug.origin}</span>
                                </Col>
                                <Col span={8}>
                                    <p className="form-field-label">
                                        Relationship to Eezee: </p>
                                    <span className="bigger-text">{bug.relationship}</span>
                                </Col>
                            </Row>
                            <Row>
                                {!readOnly && <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                </Form.Item>}
                            </Row>

                        </Form>
                    </Row>

                    {readOnly && 
                    <Row>
                        <Col span={10}>
                            <BugComments
                                bugId={bug._id}
                                comments={bug.comments}
                                handleSubmitComment={this.handleSubmitComment}
                            />
                        </Col>
                        <Col span={14}>
                            <Logs
                                bugId={bug._id}
                                logs={this.state.logs}
                                logUserEmail={this.logUserEmail}
                            />
                        </Col>
                    </Row>}
            </Card>
        )
    }

    constructor(props) {
        super(props)

        const { bugId } = this.props.match.params

        this.state = {
            bug: false,
            imageUrl: false,
            readOnly: bugId,
            loading: bugId,
            renderModal: false,
            modalVisible: false,
            reassignUserEmail: false,
            reassignReason: false,
            logs: [],
            emailModalVisible: false,
        }

        
        if (bugId) {
            _getBug(bugId)
                .then(res => {

                    this.getLogs()
                    this.setState({
                        loading: false,
                        bug: res.data.bug,
                        imageUrl: res.data.bug.screenshots.length > 0 ? res.data.bug.screenshots : res.data.bug.screenshot
                    })
                })
        }
    }

    getLogs = () => {
        const { bugId } = this.props.match.params

        _getBugLogs({bugId})
        .then( res => {
            this.setState({
                logs: res.data.bugLogs
            })
        })
    }

    handleSubmitComment = ({bugId, comment, parent=-1})=>{

        _postSubmitBugComment({ bugId, comment, parent })
        .then( res => {
            this.setState({
                bug: {
                    ...this.state.bug,
                    comments: res.data.comments
                }
            })
        })
    }

    handleConfirmClose = () => {
        confirm({
            centered: true,
            title: 'Close Issue? Please provide a message',
            content: <Input
                onChange={(e)=>this.setState({ closeReason: e.target.value})}
            />,
            onOk: this.handleClose
        })
    }

    handleClose = () => {

        const { closeReason } = this.state

        if( !closeReason || closeReason.length == 0 ){
            return message.warning('Need message for closing')
        }

        _postCloseBug(this.state.bug._id, closeReason)
            .then(res => {
                this.getLogs()
                this.setState({
                    bug: res.data.bug
                })
            })
    }

    handleConfirmReopen = () => {

        confirm({
            centered: true,
            title: 'Reopen Issue? Please provide a message',
            content: <Input
                onChange={(e)=>this.setState({ reopenReason: e.target.value})}
            />,
            onOk: this.handleReopen
        })

    }

    handleReopen = () => {

        const { reopenReason } = this.state

        if( !reopenReason || reopenReason.length == 0 ){
            return
        }

        _postReopenBug({bugId: this.state.bug._id, reason: reopenReason})
        .then( res => {
            this.getLogs()
            this.setState({
                bug: res.data.bug
            })
        })

    }

    handleReassign = () => {
        const { reassignUserEmail, reassignReason } = this.state

        this.setState({
            loading: true
        })

        _postReassignBug(this.state.bug._id, reassignUserEmail, reassignReason)
            .then(res => {

                this.setState({
                    loading: false,
                    renderModal: false,
                    modalVisible: false,
                }, () => {
                    if( res.data.message ){
                        return message.error(res.data.message)
                    }

                    this.getLogs()
                    this.setState({
                        bug: {
                            ...this.state.bug,
                            agent: res.data.bug.agent,
                        },
                        reassignUserEmail: false,
                    })
                })

            })
            // .catch(err => {
            //     message.error("No developer found with that email")
            //     this.setState({
            //         loading: false
            //     })
            // })
    }

    handleReassignInputChange = (e) => {
        this.setState({
            reassignUserEmail: e.target.value
        })
    }

    handleClaim = () => {

        _postClaimBug(this.state.bug._id)
            .then(res => {

                message.success("Bug claimed!")
                this.getLogs()
                this.setState({
                    bug: {
                        ...this.state.bug,
                        agent: res.data.bug.agent
                    }
                })
            })
            .catch(err => {
                if (this.state.bug.type=='Technical') {
                    message.error("This is for developer to claim")
                    return
                }
                if (this.state.bug.type=='General') {
                    message.error("This is for operations to claim")
                    return
                }
                message.error("You are not the right person to claim this")
            })

    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {

                const {
                    severity,
                    reportedByEmail,
                    description,
                    url,
                    type
                } = values

                const { imageUrl } = this.state

                if( this.state.bug._id ){

                    _postEditBug({
                        bugId: this.state.bug._id,
                        severity,
                        reportedByEmail,
                        description,
                        url,
                        imageUrl,
                        type
                    })
                    .then( res => {
                        message.success("Edit success")

                        this.setState({
                            bug: res.data.bug,
                            readOnly: true
                        })
                    })
                    
                } else {
                    _postCreateBug({
                        severity,
                        reportedByEmail,
                        description,
                        url,
                        imageUrl,
                        type                        
                    })
                        .then(res => {
                            message.success('Report success')
                            this.getLogs()
                            window.open(`/bugs/${res.data.bug._id}`)
                        })
                }


            }
        });
    };

    handleChange = ({fileList}) => {
        if (fileList[fileList.length-1].status === 'done') {

            fileList = fileList.map( _file => {
                return {
                    uid: _file.uid,
                    name: _file.name ,
                    status: _file.status,
                    url: _file.response.screenshot.url 
                }
            })

            this.setState({ imageUrl: fileList })
        }
    }
    
    normFile = e => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    handleSendEmail = (message) => {

        _sendBugUpdateEmailToUser({
            message,
            bugId: this.state.bug._id
        })
        .then(res => {
            this.setState({emailModalVisible : false})
            this.getLogs()
        })
        .catch( err => console.log(err))
    }

    renderStatus= (status) => {
        
        if (status == STATUS.CLOSED) {
            return <Badge text={status} status={'default'} />
        }


        if (status == STATUS.OPEN) {
            return <Badge text={status} status={'success'} />
        }


        if (status == STATUS.INPROGRESS) {
            return <Badge text={status} status={'processing'} />
        }
        
    }

    logUserEmail = (message) => {

        const { bugId } = this.props.match.params
        
        _postBugLog({bugId, message, action: 'EMAIL_REC'})
        .then(_bugLog => {
            this.getLogs()
            this.setState({})
        })
    }

}

export default connect(
    state => ({
        user: state.user.data
    })
)(withRouter(Form.create({})(BugEditor)))


// WEBPACK FOOTER //
// ./src/components/bug-report/editor.js